module.exports = function getResource(label, vars = []) {
    let resources = {
        samplesSelectedText: `${vars[0]} of ${vars[1]} sample(s) selected`,
        selectSamplesOrderText: `You can select up to ${vars[0]} sample(s) per order.`
    };

    return resources[label];
};
